import * as React from "react";
import { useContext } from "react";
import { FormComponentProps } from "antd/lib/form";
import { Row } from "antd";
import { AuthContext } from "src/components/context/AuthContext";
import "./SpecialProjectCommissionSliderComponent.scss";
import { SliderMarkComponent } from '../SliderMarkComponent/SliderMarkComponent';
import { IExceedMaxPriceBalance } from "src/services/interfaces/IExceedMaxPriceBalance";
import { SliderMarks } from "antd/lib/slider";
import { MoneyMask } from "src/util/Masks/MoneyMask";

interface ISpecialProjectCommissionSliderComponentProps extends FormComponentProps {
  minCommission: number;
  maxCommission: number;
  commission: number;
  minPrice: number;
  maxPrice: number;
  price: number;
  balance: IExceedMaxPriceBalance;
  handleChangePrice: (value: number) => void;
  handleChangeCommission: (value: number) => void;
  disableCommissionSlider: boolean;
  canEditQuotePrice: boolean;
  provisionedAmount?: number;
}
export const SpecialProjectCommissionSliderComponent: React.FC<ISpecialProjectCommissionSliderComponentProps> = ({
  minCommission,
  maxCommission,
  commission,
  minPrice,
  maxPrice,
  price,
  balance,
  handleChangePrice,
  handleChangeCommission,
  disableCommissionSlider,
  canEditQuotePrice,
  provisionedAmount,
  form
}) => {
  const { currentUser } = useContext(AuthContext);

  const marks: SliderMarks = {
    [minPrice]: {
      label: MoneyMask(minPrice),
      style: {
        left: '1%'
      },

    },
    [maxPrice]: MoneyMask(maxPrice),
    ...(!!balance ?
      {
        [maxPrice + balance?.available + provisionedAmount || 0]: {
          label: MoneyMask(maxPrice + balance?.available + provisionedAmount || 0),
          style: {
            left: '98%'
          }
        }
      } : {})
  }

  return (
    <>
      {canEditQuotePrice && (
        <>
          <Row>
            <SliderMarkComponent
              form={form}
              isExceeding={false}
              handleChange={handleChangeCommission}
              value={commission}
              marks={
                {
                  [minCommission]: {
                    label: MoneyMask(minCommission),
                    style: {
                      left: '2%'
                    },
                  },
                  [maxCommission]: {
                    label: MoneyMask(maxCommission),
                    style: {
                      left: '98%'
                    },
                  }
                }
              }
              minValue={minCommission}
              maxValue={maxCommission}
              needToPrecifyPercentLender={disableCommissionSlider}
              title="Comissão R$"
              isVisible={currentUser.permissions.userCanSeeCommission}
              fieldName="commission"
            />
          </Row>

          <Row>
            <SliderMarkComponent
              form={form}
              handleChange={handleChangePrice}
              value={price}
              isExceeding={price > maxPrice}
              minValue={Number(Object.keys(marks)[0])}
              maxValue={Number(Object.keys(marks)[Object.keys(marks).length - 1])}

              marks={marks}
              needToPrecifyPercentLender={false}
              title="Preço"
              isVisible={currentUser.permissions.userCanSeeCommission}
              fieldName="price"
            />
          </Row>
        </>
      )}
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/PricingComponents/SpecialProjectCommissionSliderComponent/SpecialProjectCommissionSliderComponent.tsx